jQuery(($) => {
    // ...
})